var _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPayVisa(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 29,
    viewBox: "0 0 42 29"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "pay-visa_svg__a",
    x1: "100%",
    x2: "0%",
    y1: "26.162%",
    y2: "73.838%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0250A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#203A7E"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#pay-visa_svg__a)",
    d: "M3.936 0h34.126C40.235 0 42 1.772 42 3.955v21.09A3.947 3.947 0 0138.062 29H3.936C1.763 29 0 27.23 0 25.046V3.955C0 1.772 1.763 0 3.936 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M26.245 9c1.07 0 1.924.21 2.472.407l-.374 2.1-.248-.113a5.264 5.264 0 00-2.061-.37c-1.079 0-1.576.43-1.576.833-.008.453.582.753 1.545 1.2 1.588.693 2.322 1.53 2.31 2.633-.017 2.01-1.9 3.31-4.793 3.31-1.235-.012-2.42-.247-3.066-.517l.386-2.17.355.155c.905.362 1.492.508 2.589.508.794 0 1.64-.296 1.649-.944.006-.425-.355-.729-1.425-1.204-1.048-.463-2.425-1.24-2.415-2.631C21.61 10.314 23.526 9 26.245 9zm9.527.177L38 18.86h-2.555s-.252-1.112-.338-1.451h-.617l-2.906-.005c-.107.262-.578 1.456-.578 1.456h-2.891l4.089-8.879c.288-.631.781-.803 1.443-.803h2.125zm-15.32-.008l-1.722 9.687H15.98l1.72-9.687h2.753zm-11.976 0c.6.022 1.082.205 1.246.817l.964 4.453.291 1.343 2.694-6.606h2.916l-4.332 9.67-2.914.003-2.443-8.394A11.758 11.758 0 004 9.371l.037-.202h4.439zm25.364 2.62c-.142.364-.383.95-.366.924 0 0-.867 2.15-1.095 2.708h2.284l-.637-2.797-.186-.836z"
  }))));
}

export default SvgPayVisa;